import React from 'react'
import PropTypes from 'prop-types'

const MaleDailyArticleCardFour = ({ isMobile, title, url, category }) => {
  const device = isMobile ? 'mobile' : 'desktop'

  return (
    <>
      <a
        className={`article-style-four article-style-four--${device}`}
        href={url}
      >
        <div className="article-style-four__divider" />
        <div className="article-style-four__text">
          <div className="article-style-four__category fd-body-sm-regular">
            {category?.replace(/_/gi, ' ')}
          </div>
          <div className="article-style-four__title fd-heading-4">{title}</div>
        </div>
      </a>
      <style jsx>
        {`
          .article-style-four {
            display: flex;
            flex-direction: column;
            gap: 20px;
            text-decoration: none;
          }

          .article-style-four--mobile {
            grid-template-columns: 156px 1fr;
          }

          .article-style-four__divider {
            border-top: 1px solid var(--border-default);
            width: 100%;
          }

          .article-style-four__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .article-style-four__image--mobile {
            width: 156px;
            height: auto;
          }

          .article-style-four__category {
            color: var(--text-sub);
            text-transform: capitalize;
          }

          .article-style-four__title {
            color: var(--text-default-inverse);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            word-break: break-word;
          }

          .article-style-four__title:hover {
            text-decoration: underline;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardFour.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  category: PropTypes.string,
  isMobile: PropTypes.bool,
}

export default MaleDailyArticleCardFour
